export const BorderLine = "1px solid rgb(237, 235, 233)";

export const SwaggerEditorStyles = {
    container: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'`,
    },
    toolbar: {
        borderBottom: "1px solid",
        borderBottomColor: "divider",
    },
    editorWrapper: {
        display: "flex",
        flexGrow: 1,
        width: "100%",
        height: "100%",
    },
    monacoEditorContainer: {
        flexBasis: "50%",
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        borderRight: "1px solid",
        borderRightColor: 'divider'
    },
    monacoEditorWrapper: {
        flex: "1 1 80%",
        overflow: "auto",
        minHeight: 0,
    },
    monacoError: {
        flex: "0 1 20%",
        overflow: "auto",
    },
    swaggerContainer: {
        width: "50%",
        minHeight: "auto",
        overflow: "auto",
        maxHeight: "calc(100vh - 140px)",
        "&::-webkit-scrollbar": {
            width: "6px",
        },
        "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
        },
    },
    swaggerWrapper: {
        flexBasis: "50%",
        minWidth: 0,
    }
};